import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWasserkw = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 90,
	height: 85,
	viewBox: "0 0 200 200",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#00488E",
		className: "cls-1",
		d: "M119.66,163.71c-5.37,3.48-10,6.49-19.77,6.49s-14.4-3.01-19.77-6.49c-5.85-3.79-12.48-8.1-25.2-8.1v10c9.76,0,14.39,3.01,19.76,6.49,5.85,3.8,12.48,8.1,25.21,8.1s19.35-4.3,25.21-8.09c5.37-3.48,10.01-6.49,19.78-6.49h.2v-10h-.2c-12.73,0-19.37,4.3-25.22,8.1Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#00488E",
		className: "cls-1",
		d: "M155.75,20l-2.47,15.2H70v-15.2h-31.41L10,134.58v15.61c12.71,0,19.34-4.3,25.18-8.1,5.36-3.48,9.99-6.49,19.74-6.49s14.39,3.01,19.76,6.49c5.85,3.8,12.48,8.1,25.21,8.1s19.35-4.3,25.21-8.09c5.37-3.48,10.01-6.49,19.78-6.49h.2c9.75,0,14.38,3.01,19.74,6.49,5.85,3.8,12.47,8.1,25.18,8.1V20h-34.25Zm-4.09,25.2l-1.62,10H70v-10h81.65ZM29.74,133.71c-3.11,2.02-5.98,3.87-9.74,5.08v-2.98L46.41,30h13.59v28.54c-4.35,6.08-20.04,30.58-22.44,70.65-2.96,1.38-5.46,2.99-7.82,4.52Zm18.06-7.58c2.8-33.44,15.56-54.73,19.77-60.93h18.32c-5.82,10.42-14.76,30.96-17.68,62.37-3.61-1.18-7.89-1.95-13.28-1.95-2.62,0-4.97,.19-7.12,.51Zm32.32,7.58c-.74-.48-1.5-.97-2.27-1.46,2.9-38.64,15.58-60.76,19.74-67.06h24.75c-7,11.15-16.88,34.03-17.32,74.68-1.55,.21-3.24,.32-5.13,.32-9.77,0-14.4-3.01-19.77-6.49Zm39.54,0c-1.54,1-3.02,1.95-4.58,2.81,.7-27.36,5.94-45.28,10.4-55.7,3.67-8.58,7.35-13.5,9.18-15.63h13.74l-9.88,60.82c-8.75,1.15-14.07,4.59-18.86,7.7Zm50.6,0c-5.26-3.42-11.17-7.23-21.57-7.96l15.56-95.75h15.75v108.79c-3.76-1.21-6.63-3.06-9.74-5.08Z"
	})]
});
export default SvgWasserkw;
